import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import { useAppDispatch, useAppSelector, useBrowserBackClickHandler } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { VerificationMethod } from '../../components/PasswordRecovery/VerificationMethod';
import { Confirmation } from '../../components/PasswordRecovery/Confirmation';
import { PasswordRecoveryStep } from '../../enums';
import { passwordRecoveryActions } from '../../redux/slices/passwordRecoverySlice';
import { SetNewPassword } from '../../components/PasswordRecovery/SetNewPassword';
import { Helmet } from '../../../../components/Helmet';

export const PasswordRecoveryPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { step } = useAppSelector((state) => state.recruiterAppPasswordRecovery);
    const { referrer } = useAppSelector((state) => state.app);

    const [savedReferrerLocation, setSavedReferrerLocation] = useState('');

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        return function () {
            dispatch(passwordRecoveryActions.clearData());
        };
    }, []);

    useEffect(() => {
        if (location.state?.from?.pathname) {
            setSavedReferrerLocation(location.state.from.pathname);
        }
    }, [location]);

    const onBackClick = useCallback(() => {
        if (step === PasswordRecoveryStep.VerificationMethod) {
            if (savedReferrerLocation) {
                navigate(savedReferrerLocation);
                return;
            }
            if (referrer) {
                window.location.href = referrer;
                return;
            }
        }

        dispatch(passwordRecoveryActions.setStep(step - 1));
    }, [step, referrer, savedReferrerLocation]);

    useBrowserBackClickHandler(onBackClick);

    const content = useMemo(() => {
        switch (step) {
            case PasswordRecoveryStep.VerificationMethod:
                return <VerificationMethod />;
            case PasswordRecoveryStep.Confirmation:
                return <Confirmation />;
            case PasswordRecoveryStep.NewPassword:
                return <SetNewPassword />;
        }
    }, [step]);

    return (
        <>
            <Helmet pageName={__t('Восстановление пароля')} />
            <div className='password-recovery-page'>
                <Header title={__t('Восстановление пароля')} onBackClick={onBackClick} />
                {content}
            </div>
        </>
    );
};
